module.exports = __webpack_public_path__ + "static/media/insta.68a202c5.svg";